import ajax from "@/utils/ajax";


export function getRewardByFirehero (params, url) {
  return ajax({
    url: url + "/admin/WebSites/getRewardByFirehero",
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/webSites.js